<template>
  <div
    class="px-10 min-h-[calc(100vh_-_90px)] sm:min-h-[calc(100vh_-_90px)] overflow-x-hidden"
    style="background: rgb(69,176,88); background: linear-gradient(0deg, rgba(69,176,88,0.4) 0%, rgba(255,255,255,1) 100%);"
  >
    <div
      class="container max-w-[1200px] mx-auto flex flex-wrap items-center min-h-[calc(70vh_-_90px)] sm:min-h-[calc(100vh_-_90px)]"
    >
      <div class="py-10 w-full md:w-1/2 my-10">
        <h6 class="text-sm uppercase">Power AI Applications with CSV Data</h6>
        <h1 class="text-3xl sm:text-5xl/[60px] font-bold mt-2 mb-5">
          Transform Your CSV Data into a Dynamic RAG Application
        </h1>
        <p class="text-lg/[30px]">Upload your CSV files and unlock the potential for querying, searching, and generative AI based on your data. We vectorize your text for similarity search and Retrieval-Augmented Generation, enabling interactive experiences like Q&A and chat.</p>
        <div class="flex flex-wrap">
          <router-link
            class="mt-5 mr-5 w-full sm:w-auto cursor-pointer"
            to="/"
          >
            <button
              aria-label="Use CSV RAG to build interactive experiences from CSV files using Retrieval-Augmented Generation"
              class="uppercase text-sm bg-chateauGreen px-5 py-3 rounded-lg text-white border-2 border-white"
            >
              Get Started
            </button>
          </router-link>
        </div>
      </div>
      <div class="py-10 w-full md:w-1/2">
        <img src="/img/excel-application-for-calculations-10008902-8162166.webp" alt="excel application for calculations" width="545" height="450" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      webBaseUrl: import.meta.env.VITE_WEB_BASE_URL,
    };
  },
  mounted() {
  },
  methods: {
    
  },
};
</script>

<style lang="scss" scoped>

</style>
